import triggerTracking from '@blueprint/tracking/dist/Tracking';
import { Box } from '@zoopla-eng/zds-components/box';
import { queries } from '@zoopla-eng/zds-components/themes';
import { CmsArticleCard } from '@zoopla/cms/article-card';
import { ArticleCollection } from '@zoopla/cms/article-collection';
import { Carousel } from '@zoopla/cms/carousel';
import { NewHomesBody } from '../NewHomesBody';
import { NewHomesPageSubtitleShort } from '../NewHomesPageSubtitleShort';

type NewHomesArticleCollectionProps = {
    articleCollection: ArticleCollection;
};

function notEmpty<TValue>(value: TValue | null | undefined): value is TValue {
    return value !== null && value !== undefined;
}

export const NewHomesArticleCollection = ({
    articleCollection
}: NewHomesArticleCollectionProps) => {
    return (
        <>
            <Box pb="$S200">
                <NewHomesPageSubtitleShort>
                    {articleCollection.title}
                </NewHomesPageSubtitleShort>
            </Box>
            <Box pb="$S500">
                <NewHomesBody>{articleCollection.description}</NewHomesBody>
            </Box>
            <Carousel
                breakpoints={[
                    { size: queries.M[100], numCards: 2 },
                    { size: queries.L[100], numCards: 3 }
                ]}
            >
                {articleCollection.articles?.items
                    .filter(notEmpty)
                    .map((article, index) => (
                        <CmsArticleCard
                            article={article}
                            index={index}
                            key={`${article?.slug ?? ''}-${index}`}
                            headingLevel="h3"
                            trackingFunction={() =>
                                triggerTracking({
                                    event: 'GAEvent',
                                    eventCategory: 'content_module',
                                    eventAction: 'article_clickthrough',
                                    eventLabel: `${
                                        article?.slug ?? ''
                                    }, ${index}`
                                })
                            }
                        />
                    ))}
            </Carousel>
        </>
    );
};
